// extracted by mini-css-extract-plugin
export default {"AdSlotMail__mail":"bge_a bhe_wj bhe_a bhe_q bhe_k","AdSlotMail__mail--notLoaded":"bge_b bhe_ey bhe_bj bhe_wy","show-ad-not-loaded":"bge_c","AdSlotMail__cta":"bge_e"};